import Auth from 'shared/context/Auth'
import { useMutation } from '@tanstack/react-query'
import type { AddTrackingUserParams } from 'shared/context/Auth'

export function useAddTrackingUser() {
  return useMutation({
    mutationFn: (params: AddTrackingUserParams) => Auth.addTrackingUser(params),
  })
}
